import type { Task } from "@gearbox-protocol/deploy-tools-shared";
import type { RouterTestResult } from "@gearbox-protocol/router-graph-ui";
import { api } from "api";
import { useAsync } from "react-use";

export default function useRouterTestResults(task: Task) {
  return useAsync(async () => {
    return api.fetchTaskArtifact<RouterTestResult[]>(task, "output.json");
  }, [task]);
}
